<!--
  HeroDevice Component - Riutilizzabile e Responsive
  Componente mockup iPhone che può mostrare qualsiasi immagine nello schermo.
  L'immagine è integrata nell'SVG per garantire che rimanga sempre nei confini del dispositivo.

  Utilizzo: <HeroDevice imageSrc="/path/to/image.png" imageAlt="Descrizione immagine" />
  L'imageSrc è opzionale - se non fornito, usa l'immagine di default importata.
-->
<template>
  <div class="device-container">
    <div class="modern-phone-wrapper">
      <!-- SVG iPhone 15 Pro Mockup -->
      <svg viewBox="0 0 430 880" class="iphone-mockup" fill="none" xmlns="http://www.w3.org/2000/svg">
        <!-- Body -->
        <rect x="10" y="10" width="410" height="860" rx="60" fill="#121212" stroke="#333" stroke-width="2"/>
        <!-- Screen background -->
        <rect x="25" y="25" width="380" height="830" rx="45" fill="white" class="screen-bg"/>

        <!-- Screen Content Image inside SVG -->
        <image
          x="25"
          y="25"
          width="380"
          height="830"
          :href="computedImageSrc"
          preserveAspectRatio="xMidYMid slice"
          clip-path="url(#screen-clip)"
          @load="onImageLoad"
          @error="onImageError"
        />

        <!-- Dynamic Island -->
        <rect x="130" y="35" width="170" height="40" rx="20" fill="black"/>

        <!-- Buttons -->
        <path d="M425 200V280" stroke="#222" stroke-width="4" stroke-linecap="round"/> <!-- Power -->
        <path d="M5 180V230" stroke="#222" stroke-width="4" stroke-linecap="round"/> <!-- Vol Up -->
        <path d="M5 250V300" stroke="#222" stroke-width="4" stroke-linecap="round"/> <!-- Vol Down -->
        <path d="M5 120V150" stroke="#222" stroke-width="4" stroke-linecap="round"/> <!-- Silent -->

        <!-- Bezel Shine -->
        <rect x="10" y="10" width="410" height="860" rx="60" stroke="url(#hero-bezel-gradient)" stroke-width="4" style="pointer-events: none;"/>

        <defs>
          <linearGradient id="hero-bezel-gradient" x1="0" y1="0" x2="430" y2="880" gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#666"/>
            <stop offset="0.5" stop-color="#111"/>
            <stop offset="1" stop-color="#666"/>
          </linearGradient>
          <clipPath id="screen-clip">
            <rect x="25" y="25" width="380" height="830" rx="45"/>
          </clipPath>
        </defs>
      </svg>
    </div>
  </div>
</template>

<script>
import screenImage from '@/assets/images/screen-content-1.png'

export default {
  name: 'HeroDevice',
  props: {
    /**
     * Source URL/path of the image to display on the device screen
     * @type {String}
     */
    imageSrc: {
      type: String,
      required: false,
      default: () => screenImage
    },
    /**
     * Alternative text for the screen image (for accessibility)
     * @type {String}
     */
    imageAlt: {
      type: String,
      default: 'App Screen'
    }
  },
  computed: {
    computedImageSrc() {
      return this.imageSrc || screenImage
    }
  },
  mounted() {
    // Debug: log the image source
    console.log('HeroDevice image source:', this.computedImageSrc)

    // Fallback per browser che non supportano <image> in SVG
    this.$nextTick(() => {
      const svgImage = this.$el.querySelector('image')
      if (svgImage) {
        // Aggiungi event listener per il caricamento
        svgImage.addEventListener('load', this.onImageLoad)
        svgImage.addEventListener('error', this.onImageError)
      }
    })
  },
  methods: {
    onImageLoad() {
      console.log('HeroDevice SVG image loaded successfully')
    },
    onImageError() {
      console.error('HeroDevice SVG image failed to load:', this.computedImageSrc)
    },
    handleResize() {
      // Forza il ridisegno dell'SVG se necessario
      const svg = this.$el.querySelector('.iphone-mockup')
      if (svg) {
        svg.style.display = 'none'
        svg.offsetHeight // Trigger reflow
        svg.style.display = ''
      }
    }
  },
  mounted() {
    // Debug: log the image source
    console.log('HeroDevice image source:', this.computedImageSrc)

    // Fallback per browser che non supportano <image> in SVG
    this.$nextTick(() => {
      const svgImage = this.$el.querySelector('image')
      if (svgImage) {
        // Aggiungi event listener per il caricamento
        svgImage.addEventListener('load', this.onImageLoad)
        svgImage.addEventListener('error', this.onImageError)
      }
    })

    // Ascolta i cambiamenti di dimensione della finestra
    window.addEventListener('resize', this.handleResize)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style scoped>
.modern-phone-wrapper {
  position: relative;
  width: 100%;
  height: auto;
}

.iphone-mockup {
  width: 100%;
  height: auto;
  filter: drop-shadow(0 20px 40px rgba(0,0,0,0.3));
}

/* Responsive adjustments for mobile devices - gestite dal CSS della sezione hero */
</style>
